import { ITaxGroup } from "../models";
import { IProductionOverview, IProductionOverviewUpdate } from "../models/IProductionOverview";
import { AuthenticatedFetch, CreateAuthHeader } from "../utils/Helpers";
import { IService } from "./ICommonServices";

export class ProductionOverviewService implements IService<IProductionOverview>
{
    private controller = "api/productionoverview";

    public async GetAll(): Promise<IProductionOverview[]> 
    {
        let result: IProductionOverview[] = [];

        const requestOptions = {
            method: 'GET',
            headers: CreateAuthHeader()
        };
        
        const response = await AuthenticatedFetch(this.controller, requestOptions);
        if(!response.ok)
        {
            return result;
        }

        return await response.json() as IProductionOverview[];
    }

    public async Get(id: number): Promise<IProductionOverview> 
    {
        const requestOptions = {
            method: 'GET',
            headers: CreateAuthHeader()
        };
        
        const response = await AuthenticatedFetch(`${this.controller}/${id}`, requestOptions);
        if(!response.ok)
        {
            throw new Error("Bank not found");
        }

        return await response.json() as IProductionOverview;
    }

    public async Create(item: IProductionOverview) : Promise<string>
    {
        const requestOptions = {
            method: 'POST',
            headers: CreateAuthHeader(),
            body: JSON.stringify(item)
        };
    
        const response = await AuthenticatedFetch(this.controller, requestOptions);
        return await response.text();
    }

    public async Update(item: IProductionOverview) : Promise<string>
    {
        throw new Error("Method not implemented.");
    }

    public async Delete(id: number) : Promise<string>
    {
        const requestOptions = {
            method: 'DELETE',
            headers: CreateAuthHeader()
        };
    
        const response = await AuthenticatedFetch(`${this.controller}/${id}`, requestOptions);
        return await response.text();
    }   

    public async UpdateFull(item : IProductionOverviewUpdate) : Promise<string>
    {
        const requestOptions = {
            method: 'PATCH',
            headers: CreateAuthHeader(),
            body: JSON.stringify(item)
        };
    
        const response = await AuthenticatedFetch(this.controller, requestOptions);
        return await response.text();
    }
}
